<template>
  <div class="page-table">
    <!-- 表格 -->
    <div class="page-search">
      <a-tabs defaultActiveKey="1" @change="callback">
        <a-tab-pane tab="校区建筑楼" key="1">
          <div class="table-btn">
            <a-button @click="showModal" type="primary">添加建筑</a-button>
            <a-button @click="exportExe" type="primary">导出</a-button>
          </div>
          <div class="table-operator" style="margin-top: 15px;padding: 0;">
            <standard-table
              :pagination="PAGINATION"
              :columns="columns"
              :dataSource="dataSource"
              @change="onChange"
              @rowChange="onRowChange"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane tab="耗材管理" key="2" forceRender>
          <div class="page-search" style="padding:0 0 10px 0">
            <a-form :form="searchForm" @submit="handleSearch">
              <a-row>
                <a-col :span="6">
                  <a-form-item label="校区" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                    <a-select allowClear v-decorator="['f_eq_h__xqdm']" placeholder="请选择">
                      <a-select-option
                        v-for="schoolData in cityOptions"
                        :key="schoolData.value"
                      >{{schoolData.label}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="编码" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                    <a-input v-decorator="['f_like_h__bh']" placeholder="请输入编码" maxlength="10" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="名称" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                    <a-input v-decorator="['f_like_h__mc']" placeholder="请输入名称" maxlength="10" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="类别" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                    <a-input v-decorator="['f_like_h__lb']" placeholder="请输入类别" maxlength="10" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24" class="search-btns">
                  <a-button type="primary" html-type="submit">查询</a-button>
                  <a-button @click="hcshowModal" type="primary">添加耗材</a-button>
                  <a-button @click="hcexportExe" type="primary">导出</a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <div class="table-operator" style="margin-top: 15px;padding: 0;">
            <standard-table
              :pagination="HCPAGINATION"
              :columns="hccolumns"
              :dataSource="hcdataSource"
              @change="hconChange"
              @rowChange="hconRowChange"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane tab="报修类型" key="3">
          <div class="table-btn">
            <a-button style="float:left;margin-left:5px" @click="addonceTree" type="primary">新增一级菜单</a-button>
            <a-button @click="bxexportExe" type="primary">批量导出</a-button>
          </div>

          <ul id="treeDemo" class="ztree"></ul>
        </a-tab-pane>
      </a-tabs>
    </div>

    <!-- 弹框 -->
    <a-modal
      destroyOnClose
      :maskClosable="false"
      :title="`${ current.id ? '编辑' : '添加' }信息`"
      v-model="visible"
      @ok="handleSubmit"
    >
      <a-form :form="form">
        <a-form-item label="校区" :labelCol="{span: 5}" :wrapperCol="{span: 14}">
          <a-select
            allowClear
            :options="cityOptions"
            placeholder="全部"
            v-decorator="['xqdm',
            {
                rules:[
                { required: true,message: '请选择校区！'}
              ]
            }]"
          />
        </a-form-item>
        <a-form-item label="楼宇名称" :labelCol="{span: 5}" :wrapperCol="{span: 14}">
          <a-input
            v-decorator="['lymc',
              {
                rules:[
                  { required: true,message: '请输入楼宇名称！'},
                  { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,10}$/, message: '1-10位汉字、字母或数字组成！' }
                ]
              }
            ]"
            placeholder="请输入楼宇名称"
            maxlength="10"
          />
        </a-form-item>
        <a-row v-for="(qyfjh, index) in qyfjh" :key="index">
          <a-col :span="20">
            <a-form-item
              :label="index === 0 ? '区域房间号' : ' '"
              :labelCol="{span: 6}"
              :wrapperCol="{span: 17}"
            >
              <a-input
                v-decorator="[
                  `qyfjh[${index}]`,
                  {
                    rules: [
                      { required: true, message: '请输入区域房间号！' },
                      { pattern: /^[\s\S]{1,10}$/, message: '区域房间号长度1～10位' }
                    ]
                  }
                ]"
                type="text"
                placeholder="请输入区域房间号"
                maxlength="10"
              />
            </a-form-item>
          </a-col>
          <a-col class="addanddel" :span="4">
            <a-button @click="addList" type="primary" shape="circle" icon="plus"></a-button>
            <a-button @click="delList(index)" type="danger" shape="circle" icon="minus"></a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!-- 耗材弹窗 -->
    <a-modal
      destroyOnClose
      :maskClosable="false"
      :title="`${ hccurrent.id ? '编辑' : '添加' }耗材`"
      v-model="hcvisible"
      @ok="hchandleSubmit"
    >
      <a-form :form="hcform">
        <a-form-item label="校区" :labelCol="{span: 5}" :wrapperCol="{span: 14}">
          <a-select
            allowClear
            :options="cityOptions"
            placeholder="全部"
            v-decorator="['xqdm',
            {
                rules:[
                { required: true,message: '请选择校区！'}
              ]
            }]"
          />
        </a-form-item>
        <a-form-item label="编号" :labelCol="{span: 5}" :wrapperCol="{span: 14}">
          <a-input
            v-decorator="['bh',
              {
                rules:[
                  { required: true,message: '请输入编号！'},
                  { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,10}$/, message: '1-10位汉字、字母或数字组成！' }
                ]
              }
            ]"
            placeholder="请输入编号"
            maxlength="10"
          />
        </a-form-item>

        <a-form-item label="名称" :labelCol="{span: 5}" :wrapperCol="{span: 14}">
          <a-input
            v-decorator="['mc',
              {
                rules:[
                  { required: true,message: '请输入名称！'},
                  { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,20}$/, message: '1-20位汉字、字母或数字组成！' }
                ]
              }
            ]"
            placeholder="请输入名称"
            maxlength="20"
          />
        </a-form-item>
        <a-form-item label="规格" :labelCol="{span: 5}" :wrapperCol="{span: 14}">
          <a-input
            v-decorator="['gg',
              {
                rules:[
                  { required: true,message: '请输入规格！'}
                ]
              }
            ]"
            placeholder="请输入规格"
            maxlength="20"
          />
        </a-form-item>
        <a-form-item label="单位" :labelCol="{span: 5}" :wrapperCol="{span: 14}">
          <a-input
            v-decorator="['dw',
              {
                rules:[
                  { required: true,message: '请输入单位！'},
                  { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,10}$/, message: '1-10位汉字、字母或数字组成！' }
                ]
              }
            ]"
            placeholder="请输入单位"
            maxlength="10"
          />
        </a-form-item>
        <a-form-item label="类别" :labelCol="{span: 5}" :wrapperCol="{span: 14}">
          <a-input
            v-decorator="['lb',
              {
                rules:[
                  { required: true,message: '请输入名称！'},
                  { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,10}$/, message: '1-10位汉字、字母或数字组成！' }
                ]
              }
            ]"
            placeholder="请输入类别"
            maxlength="10"
          />
        </a-form-item>
        <a-form-item label="仓库" :labelCol="{span: 5}" :wrapperCol="{span: 14}">
          <a-input
            v-decorator="['ck',
              {
                rules:[
                  { required: true,message: '请输入仓库！'},
                  { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,20}$/, message: '1-20位汉字、字母或数字组成！' }
                ]
              }
            ]"
            placeholder="请输入仓库"
            maxlength="20"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
const env = process.env.NODE_ENV
// import'../public/zTree/css/zTreeStyle/zTreeStyle.css'
// const statusMap = ['启用', '停用'] // 0-启用、1-启用
export default {
  name: 'QueryList',
  data () {
    const columns = [
      {
        title: '序号',
        dataIndex: '_index'
      },
      {
        title: '校区',
        dataIndex: 'xqmc',
        align: 'center'
      },
      {
        title: '楼宇',
        dataIndex: 'lymc',
        align: 'center'
      },
      {
        title: '区域或房间号',
        dataIndex: 'qyfjh',
        align: 'center'
      },
      {
        title: '操作',
        align: 'center',
        width: 150,
        customRender: (text, record, index) => {
          return (
            <div class="row-operator">
              <a href="javascript:;" onClick={() => this.showModal(true, record)}>编辑</a>
              <a-divider type="vertical" />
              <a href="javascript:;" onClick={() => this.handleRemove(record)}>删除</a>
            </div>
          )
        }
      }
    ]
    const hccolumns = [
      {
        title: '校区',
        dataIndex: 'xq',
        align: 'center'
      },
      {
        title: '编码',
        dataIndex: 'bh',
        align: 'center'
      },
      {
        title: '名称',
        dataIndex: 'mc',
        align: 'center'
      },
      {
        title: '规格',
        dataIndex: 'gg',
        align: 'center'
      },
      {
        title: '单位',
        dataIndex: 'dw',
        align: 'center'
        // customRender: (text) => {
        //   return statusMap[text]
        // }
      },
      {
        title: '类别',
        dataIndex: 'lb',
        align: 'center'
      },
      {
        title: '仓库',
        dataIndex: 'ck',
        align: 'center'
      },
      {
        title: '操作',
        align: 'center',
        width: 150,
        customRender: (text, record, index) => {
          return (
            <div class="row-operator">
              <a href="javascript:;" onClick={() => this.hcshowModal(true, record)}>编辑</a>
              <a-divider type="vertical" />
              <a href="javascript:;" onClick={() => this.hchandleRemove(record)}>删除</a>
            </div>
          )
        }
      }
    ]
    return {
      HCPAGINATION: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      searchForm: this.$form.createForm(this),
      form: this.$form.createForm(this),
      hcform: this.$form.createForm(this),
      columns,
      hccolumns,
      dataSource: [],
      hcdataSource: [],
      selectedRows: [],
      visible: false,
      hcvisible: false,
      current: {},
      hccurrent: {},
      cityOptions: [],
      qyfjh: [{}],
      ztreedataSource: [],
      newCount: 1,
      workType: true,
      // 下拉
      schoolData: []
    }
  },
  mounted () {
    // 获取学校楼
    this.fetchList(this.getFetchParams())
    // 获取耗材管理
    this.material(this.getFetchParamstwo())
    // 获取报修类型
    this.repair(this.getFetchParams())
    // 获取学区下拉
    this.schoolArea()
  },
  methods: {
    // 获取学校楼
    fetchList (params) {
      params.currentPageNo = params.pageNum
      this.$axios.post('/api/xtgl/getXqjzList.do', params).then(res => {
        this.dataSource = res.rows || []
        // 处理分页情况
        const { pageNum, pageSize } = params
        this.PAGINATION = {
          total: res.total || 0,
          pageNum,
          pageSize
        }
      })
    },
    // 获取耗材管理
    material (params) {
      params.currentPageNo = params.pageNum
      params.s_h__create_date = 'desc'
      this.$axios.post('/api/xtgl/getHcList.do', params).then(res => {
        this.hcdataSource = res.rows || []
        // 处理分页情况
        const { pageNum, pageSize } = params
        this.HCPAGINATION = {
          total: res.total || 0,
          pageNum,
          pageSize
        }
      })
    },
    // 获取报修管理
    repair () {
      this.$axios.post('/api/xtgl/getBxlxList.do').then(res => {
        this.ztreedataSource = res.data.data || []
        this.ztreeGet()
      })
    },
    // 获取学区下拉
    schoolArea () {
      this.$axios.post('/api/dict/getXqInfo.do').then(res => {
        this.cityOptions = res.data.data || []
      })
    },
    // 搜索
    handleSearch (e) {
      e.preventDefault()
      let params = this.getFetchParams({ pageNum: 1 })
      this.material(params)
    },
    onRowChange (selectedRows) {
      // console.log(selectedRows)
      this.selectedRows = selectedRows
    },
    hconRowChange (selectedRows) {
      // console.log(selectedRows)
      this.selectedRows = selectedRows
    },
    // 切换数据
    onChange (changeParams) {
      this.fetchList(this.getFetchParams(changeParams))
    },
    // 耗材切换数据
    hconChange (changeParams) {
      this.material(this.getFetchParamstwo(changeParams))
    },
    /**
     * 获取请求列表参数
     * @param { Object } customParam 自定义处理
     * @return { Object } 请求列表参数
     */
    getFetchParams (customParam) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...this.PAGINATION,
        ...customParam
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = 1
        params.pageSize = 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      return params
    },
    getFetchParamstwo (customParam) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...this.HCPAGINATION,
        ...customParam
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = 1
        params.pageSize = 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      return params
    },
    // 显示弹框
    showModal (visible, record) {
      this.visible = !!visible
      this.current = record || {}
      this.qyfjh = [{}]

      // 编辑
      if (record) {
        var data = record.qyfjh.split(',')
        for (var j = 1; j < data.length; j++) {
          this.qyfjh.push({})
        }
        this.$nextTick(() => {
          let fields = this.form.getFieldsValue()
          for (let key in fields) {
            fields[key] = record[key]
          }
          fields.qyfjh = record.qyfjh.split(',')
          this.qyfjh = fields.qyfjh
          this.form.setFieldsValue(fields)
        })
      }
    },
    // 添加房间号输入框
    addList () {
      this.qyfjh.push({})
    },
    // 删除房间号输入框
    delList (index) {
      this.$confirm({
        title: '提示',
        content: '确定删除该条数据？',
        okType: 'danger',
        onOk: () => {
          if (this.qyfjh.length > 1) {
            // eslint-disable-next-line
            this.form.validateFields((err, values) => {
              this.qyfjh.splice(index, 1)
              values.qyfjh.splice(index, 1)
              this.form.setFieldsValue(values)
              this.$message.success(`删除成功！`)
            })
          } else {
            this.$message.warning(`至少保留一条数据！`)
          }
        }
      })
    },

    // 显示耗材弹框
    hcshowModal (hcvisible, record) {
      this.hcvisible = !!hcvisible
      this.hccurrent = record || {}
      // 编辑
      if (record) {
        this.$nextTick(() => {
          let fields = this.hcform.getFieldsValue()
          debugger
          for (var key in fields) {
            fields[key] = record[key]
          }
          this.hcform.setFieldsValue(fields)
        })
      }
    },
    // 顶部tab
    callback (key) {
      // console.log(key)
      if (key === '1') {
        this.fetchList(this.getFetchParams())
      } else if (key === '2') {
        this.material(this.getFetchParamstwo())
      } else if (key === '3') {
        this.repair(this.getFetchParams())
      }
    },
    // 导出excel
    exportExe (e) {
      e.preventDefault()
      let url = env === 'production' ? '/export/exportXqjz.do' : '/api/export/exportXqjz.do'
      this.epxportway(url, this.getParams())
    },
    // 导出方法
    epxportway (url, data) {
      if (url && data) {
        var form = window.$('<form></form>')
        form.attr('action', url)
        form.attr('method', 'post')
        for (var item in data) {
          var input = window.$('<input type="text" />')
          input.attr('name', item)
          input.attr('value', data[item])
          form.append(input)
        }
        form.appendTo('body').submit().remove()
      }
    },
    // 耗材导出
    hcexportExe (e) {
      e.preventDefault()
      let url = env === 'production'
        ? '/export/exportHcgl.do'
        : '/api/export/exportHcgl.do'
      this.epxportway(url, this.getParams())
    },
    // 报修导出
    bxexportExe (e) {
      e.preventDefault()
      let url = env === 'production'
        ? '/export/exportBxlx.do'
        : '/api/export/exportBxlx.do'
      this.epxportway(url, this.getParams())
    },

    // 新增、编辑
    handleSubmit () {
      let $this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          // 处理编辑时添加ID字段
          if (JSON.stringify($this.current) !== '{}') {
            values.id = $this.current.id
          }
          let iswran = false
          let hash = {}
          for (var i in values.qyfjh) {
            if (!hash[values.qyfjh[i]]) { // hash 哈希
              hash[values.qyfjh[i]] = true
            } else {
              iswran = true
            }
          }
          if (iswran) {
            $this.$message.warning(`区域房间号重复！`)
            return false
          }
          // values.type = '0' // 0-前端 1-后端
          // 接口请求
          this.submitAjax(values)
        }
      })
    },
    // 新增、编辑请求
    submitAjax (params) {
      params.qyfjh = params.qyfjh.join(',')
      this.$axios.post('/api/xtgl/saveOrUpdateXqjz.do', params).then(res => {
        this.$message.success(`${params.id ? ' 编辑' : '新增'}成功！`)
        this.visible = false
        this.fetchList(this.getFetchParams({ pageNum: 1 }))
      })
    },
    // 耗材新增、编辑
    hchandleSubmit () {
      let $this = this
      this.hcform.validateFields((err, values) => {
        if (!err) {
          // 处理编辑时添加ID字段
          if (JSON.stringify($this.hccurrent) !== '{}') {
            values.id = $this.hccurrent.id
          }
          values.type = '0'// 0-前端 1-后端
          // 接口请求
          this.hcsubmitAjax(values)
        }
      })
    },

    // 耗材新增、编辑请求
    hcsubmitAjax (params) {
      this.$axios.post('/api/xtgl/saveOrUpdateHc.do', params).then(res => {
        this.$message.success(`${params.id ? ' 编辑' : '新增'}成功！`)
        this.hcvisible = false
        this.material(this.getFetchParams({ pageNum: 1 }))
      })
    },
    // 删除
    handleRemove (record) {
      this.$confirm({
        title: '提示',
        content: '确定删除该条数据？',
        okType: 'danger',
        onOk: () => {
          // 删除请求
          this.removeAjax({ id: record.id })
        }
      })
    },
    // 删除请求
    removeAjax (params) {
      this.$axios.post('/api/xtgl/deleteXqjzById.do', params).then(res => {
        this.$message.success(`删除成功！`)

        this.fetchList(this.getFetchParams({ isRemove: true }))
      })
    },
    // 耗材删除
    hchandleRemove (record) {
      this.$confirm({
        title: '提示',
        content: '确定删除该条数据？',
        okType: 'danger',
        onOk: () => {
          // 删除请求
          this.hcremoveAjax({ id: record.id })
        }
      })
    },
    // 耗材删除请求
    hcremoveAjax (params) {
      this.$axios.post('/api/xtgl/deleteHcById.do', params).then(res => {
        this.$message.success(`删除成功！`)
        this.material(this.getFetchParamstwo({ isRemove: true }))
      })
    },
    // 获取ztree
    ztreeGet () {
      // var zTreeObj
      let $this = this
      // zTree 的参数配置，深入使用请参考 API 文档（setting 配置详解）
      var setting = {
        data: {
          simpleData: {
            enable: true
          }
        },
        view: {
          showIcon: false,
          showLine: false,
          dblClickExpand: false,
          addDiyDom: this.addDiyDom,
          nameIsHTML: true,
          selectedMulti: false,
          addHoverDom: addHoverDom,
          removeHoverDom: removeHoverDom
        },
        edit: {
          enable: true,
          removeTitle: '删除节点',
          renameTitle: '编辑节点名称'
        },
        callback: {
          onRename: zTreeOnRename,
          beforeRemove: zTreeBeforeRemove,
          beforeRename: zTreeBeforeRename
        }
      }
      // zTree 的数据属性，深入使用请参考 API 文档（zTreeNode 节点数据详解）
      var zNodes = this.ztreedataSource
      // 重命名验证
      function zTreeBeforeRename (treeId, treeNode, newName, isCancel) {
        var answer
        if (newName.length > 10) {
          $this.$message.warning(`命名字数不能超过10！`)
          answer = false
        } else if (newName.length === 0) {
          $this.$message.warning(`命名不能为空！`)
          answer = false
        } else {
          answer = true
        }
        return answer
      }

      // 重命名
      function zTreeOnRename (event, treeId, treeNode, isCancel) {
        var params = {
          id: treeNode.id,
          mc: treeNode.name
        }
        $this.$axios.post('/api/xtgl/saveOrUpdateBxlx.do', params).then(res => {
          $this.$message.success(`重命名成功！`)
        })
      }
      // 移除
      function zTreeBeforeRemove (treeId, treeNode) {
        if (!treeNode.children || treeNode.children === []) {
          $this.$confirm({
            title: '提示',
            content: '确定删除该条数据？',
            okType: 'danger',
            onOk: () => {
              // 删除请求
              $this.$axios.post('/api/xtgl/deleteBxlxById.do', { id: treeNode.id }).then(res => {
                $this.$message.success(`删除成功！`)
                // 重新获取树
                $this.repair($this.getFetchParams())
              })
            }
          })
        } else {
          $this.$message.warning(`请先删除子节点！`)
        }
        return false
      }
      // 新增按钮
      function addHoverDom (treeId, treeNode) {
        if (treeNode.level < 2) {
          // eslint-disable-next-line
          var sObj = $('#' + treeNode.tId + '_span')
          // eslint-disable-next-line
          if (treeNode.editNameFlag || $('#addBtn_' + treeNode.tId).length > 0) return
          var addStr = '<span class="button add" id="addBtn_' + treeNode.tId + '" title="新增" onfocus="this.blur();"></span>'
          sObj.after(addStr)
          // eslint-disable-next-line
          var btn = $('#addBtn_' + treeNode.tId)
          if (btn) {
            btn.bind('click', function () {
              // eslint-disable-next-line
              var zTree = $.fn.zTree.getZTreeObj('treeDemo')
              // 新增请求
              var params = {
                cj: treeNode.level + 2,
                mc: 'new node' + $this.newCount++,
                pId: treeNode.id
              }
              if ($this.workType) {
                $this.workType = false
                $this.$axios
                  .post('/api/xtgl/saveOrUpdateBxlx.do', params)
                  .then(res => {
                    $this.$message.success(`新增成功！`)
                    zTree.addNodes(treeNode, {
                      id: res.data.data.id,
                      pId: treeNode.id,
                      name: 'new node' + $this.newCount
                    })
                    var node = zTree.getNodeByParam('id', res.data.data.id, null)
                    zTree.editName(node)
                    setTimeout(function () {
                      $this.workType = true
                    }, 1000)
                  })
              }
              return false
            })
          }
        }
      }
      function removeHoverDom (treeId, treeNode) {
        // eslint-disable-next-line
        $('#addBtn_' + treeNode.tId).unbind().remove()
      }
      // eslint-disable-next-line
      $(document).ready(function () {
        // eslint-disable-next-line
        zTreeObj = $.fn.zTree.init($('#treeDemo'), setting, zNodes)
      })
    },
    // 新增一级菜单
    addonceTree () {
      let $this = this
      // eslint-disable-next-line
      var zTree = $.fn.zTree.getZTreeObj('treeDemo')
      var params = {
        cj: 1,
        mc: 'new node' + $this.newCount++,
        pId: ''
      }
      $this.$axios.post('/api/xtgl/saveOrUpdateBxlx.do', params).then(res => {
        $this.$message.success(`新增成功！`)
        zTree.addNodes({
          id: res.data.id,
          pId: '',
          name: 'new node' + $this.newCount
        })
        // 重新获取树
        $this.repair($this.getFetchParams())
        // var node = zTree.getNodeByParam('id', res.data.data.id, null);
        // zTree.editName(node)
      })
    },
    getParams (custParam) {
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...custParam,
        startTime: this.startTime,
        endTime: this.endTime
      }
      return params
    }
  }
}
</script>
<style>
.table-btn {
  text-align: right;
}
.table-btn > div {
  margin-bottom: 15px;
}
.table-btn .ant-btn {
  margin-left: 20px;
}
.ztree li span.button.add {
  background-image: url("../../assets/png/newtreepic.png");
  background-position: -110px 1px;
  vertical-align: middle;
  width: 22px;
  height: 22px;
  margin: 0 3px;
}

.ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane,
.ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane {
  min-height: 400px;
}
.addanddel .ant-btn {
  padding: 0;
  margin-top: 4px;
}
.ztree * {
  font-size: 16px;
  color: #fff;
}
.ztree li {
  width: 280px;
  line-height: 40px;
  margin-bottom: 10px;
  text-indent: 10px;
}
.ztree > li {
  background: #4b99eb;
}
.ztree li ul {
  padding-left: 145px;
  position: relative;
  padding-top: 10px;
  background: #fff
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDphNTZjOTkwZi0yZDNjLWM2NGYtYTc1NS0wNWMzMGIwM2Y2NDMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTFGQ0NFNDU3Nzc4MTFFOTg5MDNCNTM4RjI0OTAwQzciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTFGQ0NFNDQ3Nzc4MTFFOTg5MDNCNTM4RjI0OTAwQzciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphM2I1NmY3YS0yMDM3LWQ4NDYtODE1OS0wMjQ2ZDA2Y2VkM2MiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo0OTcxOGYxNi02NDI0LTExZTktOTU5OC1mNzUzOGMwMGNkZGMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7fXVddAAAAD0lEQVR42mKes+UfQIABAARKAlIhBYbGAAAAAElFTkSuQmCC)
    145px 0 repeat-y;
}
.ztree li ul:before {
  position: absolute;
  content: "";
  width: 1px;
  height: 10px;
  background: #9cb4fe;
  bottom: -10px;
  left: 145px;
}

.ztree ul li {
  margin-left: 50px;
  position: relative;
}
.ztree ul li:before {
  position: absolute;
  content: "";
  width: 50px;
  height: 1px;
  background: #9cb4fe;
  top: 20px;
  left: -50px;
}
.ztree > li > ul > li {
  background: #fdb03c;
}
.ztree > li > ul > li > ul > li {
  background: #958aff;
}
.ztree li a.curSelectedNode {
  background-color: inherit;
  border: none;
}
.ztree li a input.rename {
  color: #333;
  height: 25px;
  width: 200px;
}
.ztree li a {
  height: 40px;
  width: 240px;
}
.ztree li a .button {
  float: right;
  margin-top: 8px !important;
}
.ant-layout-content .page-search {
  border-bottom: none;
}
.search-btns {
  margin-top: 10px;
}
.search-btns button {
  margin-left: 20px;
}
</style>
